import { AppThunk } from '../../../../storage/store';
import {
  fetchStart,
  fetchSuccess,
  fetchFailed,
  updateStart,
  updateSuccess,
  updateFailed,
} from './slice';
import { fetchVendorCommissionsAPI, updateVendorCommissionAPI } from './api';
import { getToken } from '../../../../utils/auth';

export const getVendorCommissions = (): AppThunk => async (dispatch) => {
  dispatch(fetchStart());
  try {
    const token = getToken() || '';
    const response = await fetchVendorCommissionsAPI(token);
    dispatch(fetchSuccess(response.data || []));
  } catch (err: any) {
    dispatch(fetchFailed(err?.message || 'Failed to load commission rates.'));
  }
};

export const setVendorCommission = (
  vendorId: number,
  commissionPercentage: number
): AppThunk => async (dispatch) => {
  dispatch(updateStart());
  try {
    const token = getToken() || '';
    const response = await updateVendorCommissionAPI(token, vendorId, { commissionPercentage });
    dispatch(
      updateSuccess({
        vendor_id: response.data.vendor_id,
        new_percentage: response.data.new_percentage,
        message: response.message || 'Commission rate updated successfully.',
      })
    );
  } catch (err: any) {
    dispatch(updateFailed(err?.message || 'Failed to update commission rate.'));
  }
};
